import React from "react";
import "./Notice.scss";

import Notice1 from "../../images/noticia/1.webp";
import Notice2 from "../../images/noticia/2.webp";
import Notice3 from "../../images/noticia/3.webp";
import Notice4 from "../../images/noticia/4.webp";
import Notice5 from "../../images/noticia/5.webp";
import Notice6 from "../../images/noticia/6.webp";
import Notice7 from "../../images/noticia/7.webp";
import Notice8 from "../../images/noticia/8.webp";
import Notice9 from "../../images/noticia/9.webp";

export default function Notice() {
  const noticiasPrevidenciario = [
    {
      image: Notice1,
      titulo: "INSS 2026: veja como o novo teto afeta sua contribuição",
      text: "O reajuste do teto do INSS altera valores e faixas de contribuição, impactando diretamente trabalhadores, segurados e o planejamento previdenciário.",
      fonte: "CNN Brasil",
    },
    {
      image: Notice2,
      titulo: "13º do INSS antecipado: quem tem direito e como receber",
      text: "A antecipação do 13º salário do INSS pode beneficiar milhões de segurados. Entenda quem tem direito ao pagamento e como funciona a liberação dos valores.",
      fonte: "InfoMoney",
    },
    {
      image: Notice3,
      titulo: "Escala 6x1 pode mudar: o que isso impacta no seu trabalho?",
      text: "O debate sobre a escala 6x1 pode trazer mudanças relevantes nas relações de trabalho, afetando direitos, rotinas e a organização de empresas e trabalhadores.",
      fonte: "Agência Brasil",
    },
    {
      image: Notice4,
      titulo: "Prazo prorrogado: ainda dá tempo de pedir ressarcimento ao INSS",
      text: "O governo ampliou o prazo para solicitação de ressarcimento, permitindo que segurados regularizem valores e evitem prejuízos.",
      fonte: "CNN Brasil",
    },
  ];

  const noticiasEmpresarial = [
    {
      image: Notice5,
      titulo: "Sua empresa está em crise? Entenda como a recuperação judicial pode ajudar",
      text: "A recuperação judicial permite reorganizar dívidas, evitar a falência e manter a operação da empresa, preservando atividades e empregos em momentos críticos.",
      fonte: "ConJur",
    },
    {
      image: Notice6,
      titulo: "Reforma tributária: sua empresa precisa revisar contratos agora",
      text: "As novas regras tributárias exigem atenção imediata. Revisar contratos é essencial para reduzir riscos fiscais e reforçar a segurança jurídica nas operações empresariais.",
      fonte: "Exame",
    },
    {
      image: Notice7,
      titulo: "Sua empresa pode estar perdendo competitividade por causa de patentes",
      text: "A demora na concessão de patentes impacta a inovação e pode limitar o crescimento das empresas, afetando diretamente a competitividade no mercado.",
      fonte: "CNN Brasil",
    },
    {
      image: Notice8,
      titulo: "Fundos imobiliários vão mudar: o que isso significa para você?",
      text: "A proposta de reforma da CVM pode alterar regras dos fundos imobiliários, com efeitos relevantes para investidores, gestores e estratégias patrimoniais.",
      fonte: "InfoMoney",
    },
  ];

  const noticiasFamily = [
    {
      image: Notice9,
      titulo: "Divórcio e partilha mais simples: veja o que mudou na lei",
      text: "Novas regras para divórcio, inventário e partilha de bens buscam simplificar procedimentos e tornar esses processos mais rápidos e acessíveis.",
      fonte: "CNN Brasil",
    },
  ];

  return (
    <div className="row">
      <div className="col-12">
        <div className="content">
          <section id="noticias">

            <div className="box text-left" id="precatorios">
              <h2 className="cl-gold f-35 nt2">
              NOTÍCIAS SOBRE PREVIDENCIÁRIO E TRABALHISTA
              </h2>
              <div className="d-flex flex-wrap justify-content-center justify-content-lg-between">
              {noticiasPrevidenciario.map((data) => (
                <div className="notice">
                  <img src={data.image} alt={data.titulo} />
                  <div className="texts">
                    <h4>{data.titulo}</h4>
                    <p>{data.text}</p>
                    <span>
                      <b>Fonte:</b> {data.fonte}
                    </span>
                  </div>
                </div>
              ))}
              </div>
            </div>

            <div className="box text-left" id="empresarial">
              <h2 className="cl-gold f-35 nt1 mt-4">
              NOTÍCIAS SOBRE EMPRESARIAL
              </h2>
              <div className="d-flex flex-wrap justify-content-center justify-content-lg-between">
              {noticiasEmpresarial.map((data) => (
                <div className="notice">
                  <img src={data.image} alt={data.titulo} />
                  <div className="texts">
                    <h4>{data.titulo}</h4>
                    <p>{data.text}</p>
                    <span>
                      <b>Fonte:</b> {data.fonte}
                    </span>
                  </div>
                </div>
              ))}
              </div>
            </div>

            <div className="box text-left" id="familia">
              <h2 className="cl-gold f-35 nt3 mt-4">
              NOTÍCIAS SOBRE PROCESSOS DE FAMÍLIA
              </h2>
              <div className="d-flex flex-wrap justify-content-center justify-content-lg-between">
              {noticiasFamily.map((data) => (
                <div className="notice">
                  <img src={data.image} alt={data.titulo} />
                  <div className="texts">
                    <h4>{data.titulo}</h4>
                    <p>{data.text}</p>
                    <span>
                      <b>Fonte:</b> {data.fonte}
                    </span>
                  </div>
                </div>
              ))}
              </div>
            </div>


          </section>
        </div>
      </div>
    </div>
  );
}
